import React, { Component } from 'react';

const appStorage = {
  data: {},
  tempData: {},
  __subscribers: [],
  init: (defaultData, defaultTempData) => {
    if (typeof localStorage === 'undefined') {
      return;
    }

    appStorage.data =
      JSON.parse(localStorage.getItem(appStorage.__storage_key)) ||
      defaultData ||
      {};

    appStorage.__trigger_update();
    appStorage.tempData = defaultTempData || {};
  },
  set: (key, value) => {
    appStorage.data[key] = value;

    appStorage.__presist();
    appStorage.__trigger_update();
  },
  setTempData: (key, value) => {
    appStorage.tempData[key] = value;
    appStorage.__trigger_update();
  },
  delete: key => {
    delete appStorage.data[key];

    appStorage.__presist();
    appStorage.__trigger_update();
  },
  __trigger_update: () => {
    appStorage.__subscribers.forEach(c => c());
  },
  __presist: () => {
    if (typeof localStorage === 'undefined') {
      return;
    }

    localStorage.setItem(
      appStorage.__storage_key,
      JSON.stringify(appStorage.data)
    );
  },
  __storage_key: `${process.env.REACT_APP_LOCALSTORAGE_PREFIX}.appStorageData`,
  subscribe: callback => {
    appStorage.__subscribers.push(callback);
  },
  unSubscribe: callback => {
    appStorage.__subscribers = appStorage.__subscribers.filter(
      c => c !== callback
    );
  }
};

export const withAppStorage = ComponentToExtend => {
  return class AppStorage extends Component {
    constructor(props) {
      super(props);

      this.state = {
        appStorageData: appStorage.data,
        appStorageTempData: appStorage.tempData,
        appStorage: appStorage
      };

      this.onAppStorageUpdated = () => {
        this.setState({
          appStorageData: appStorage.data,
          appStorageTempData: appStorage.tempData,
          appStorage
        });
      };
    }

    componentDidMount() {
      appStorage.subscribe(this.onAppStorageUpdated);
    }

    componentWillUnmount() {
      appStorage.unSubscribe(this.onAppStorageUpdated);
    }

    render() {
      let { appStorage, appStorageData, appStorageTempData } = this.state;

      return (
        <ComponentToExtend
          appStorage={appStorage}
          appStorageData={appStorageData}
          appStorageTempData={appStorageTempData}
          {...this.props}
        />
      );
    }
  };
};

export default appStorage;
